import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const API_BASE_URL = AppSettings.GMS_BACKEND_API_URL;


export const fetchCategoriesAndCategoryTypes = async (params: {
    search?: string;
    channelKey?: string;
    sort_by?: SortOption;
    sort_order?: SortOrder;
    filters?: FilterOptions;
}) => {
    try {
        const queryParams = new URLSearchParams();
        if (params.sort_by) queryParams.append('sort_by', params.sort_by);
        if (params.sort_order) queryParams.append('sort_order', params.sort_order.toString());
        if (params.search) queryParams.append('search', params.search);

        if (params.filters) {
            if (params.filters.categories && params.filters.categories.length > 0) {
                const categoryIds = params.filters.categories.map(cat =>
                    typeof cat === 'string' ? cat : cat.category_id
                );
                const categoryIdsString = categoryIds.join(',');
                queryParams.append('categories', categoryIdsString);
            }

            if (params.filters.category_types && params.filters.category_types.length > 0) {
                const categoryTypeIds = params.filters.category_types.map(type =>
                    typeof type === 'string' ? type : type.category_type_id
                );
                const categoryTypeIdsString = categoryTypeIds.join(',');
                queryParams.append('category_types', categoryTypeIdsString);
            }
            if (params.filters.co_sold_categories && params.filters.co_sold_categories.length > 0) {
                const coSoldCategoryIds = params.filters.co_sold_categories.map(cat =>
                    typeof cat === 'string' ? cat : cat.category_id
                );
                const coSoldCategoryIdsString = coSoldCategoryIds.join(',');
                queryParams.append('co_sold_categories', coSoldCategoryIdsString);
            }

            if (params.filters.co_sold_category_types && params.filters.co_sold_category_types.length > 0) {
                const coSoldCategoryTypeIds = params.filters.co_sold_category_types.map(type =>
                    typeof type === 'string' ? type : type.category_type_id
                );
                const coSoldCategoryTypeIdsString = coSoldCategoryTypeIds.join(',');
                queryParams.append('co_sold_category_types', coSoldCategoryTypeIdsString);
            }
            if (params.filters.is_curated !== undefined) {
                queryParams.append('is_curated', params.filters.is_curated.toString());
            }
        }

        const url = `${API_BASE_URL}relevant_category/categories/${params.channelKey}?${queryParams}`;
        const response = await ServiceWrapper.doGet(
            url,
            null,
            null,
            AuthManager.getGmsToken());

        if (response.errorfound) {
            throw new Error('Failed to fetch categories');
        }

        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
};

export const fetchCoSoldCategories = async (
    categoryId: string,
    channelKey: string,
    params: {
        search?: string;
        limit?: number;
        filters?: FilterOptions;
        is_curated?: boolean;
        sort_by?: SortOption;
        sort_order?: SortOrder;
    }
) => {
    try {
        const queryParams = new URLSearchParams();

        if (params.limit) {
            queryParams.append('limit', params.limit.toString());
        }

        if (params.sort_by !== undefined && params.sort_order !== undefined) {
            if (!["category_name", "category_type_name"].includes(params.sort_by)) {
                const sortFieldMap: Record<string, string> = {
                    "co_sold_category": "category_name",
                    "co_sold_category_type": "category_type_name"
                };
                const sortField = sortFieldMap[params.sort_by] || params.sort_by;
                queryParams.append('sort_by', sortField.toString());
                queryParams.append('sort_order', params.sort_order.toString());
            }
        }

        if (params.filters) {

            if (params.search) queryParams.append('search', params.search);

            if (params.filters.category_types && params.filters.category_types.length > 0) {
                const categoryTypeIds = params.filters.category_types.map(type =>
                    typeof type === 'string' ? type : type.category_type_id
                );
                const categoryTypeIdsString = categoryTypeIds.join(',');
                queryParams.append('category_types', categoryTypeIdsString);
            }

            if (params.filters.co_sold_categories && params.filters.co_sold_categories.length > 0) {
                const coSoldCategoryIds = params.filters.co_sold_categories.map(cat =>
                    typeof cat === 'string' ? cat : cat.category_id
                );
                const coSoldCategoryIdsString = coSoldCategoryIds.join(',');
                queryParams.append('co_sold_categories', coSoldCategoryIdsString);
            }

            if (params.filters.co_sold_category_types && params.filters.co_sold_category_types.length > 0) {
                const coSoldCategoryTypeIds = params.filters.co_sold_category_types.map(type =>
                    typeof type === 'string' ? type : type.category_type_id
                );
                const coSoldCategoryTypeIdsString = coSoldCategoryTypeIds.join(',');
                queryParams.append('co_sold_category_types', coSoldCategoryTypeIdsString);
            }

            if (params.filters.is_curated !== undefined) {
                queryParams.append('is_curated', params.filters.is_curated.toString());
            }
        }

        const url = `${API_BASE_URL}relevant_category/co_sold_categories/${channelKey}/${categoryId}?${queryParams}`;
        const response = await ServiceWrapper.doGet(url, null, null, AuthManager.getGmsToken());

        if (response.errorfound) {
            throw new Error('Failed to fetch co-sold categories');
        }

        return response.data;
    } catch (error) {
        console.error('Error fetching co-sold categories:', error);
        throw error;
    }
};

export const toggleCuration = async (channelId: string, parentCategoryId: string, coSoldCategoryId: string, isCurated: boolean) => {
    try {
        const url = `${API_BASE_URL}relevant_category/update_curation/${channelId}`;
        const data = [
            {
                "co_sold_categories": [
                    {
                        "category_id": coSoldCategoryId,
                        "active": isCurated
                    }
                ],
                "category_id": parentCategoryId
            }
        ];

        const response = await ServiceWrapper.doPut(url,
            data,
            null,
            AuthManager.getGmsToken());

        if (response.errorfound) {
            throw new Error('Failed to toggle curation');
        }

        return response.data;
    } catch (error) {
        console.error('Error toggling curation:', error);
        throw error;
    }
}
